import { renderToString } from 'react-dom/server';

import { StyledLegendBulletContainer, StyledLegendBulletCircle, StyledLegendBulletName } from './legendBulletStyles';

interface ILegendBulletProps {
  color: string;
  name: string;
}

export const LegendBullet = ({ color, name }: ILegendBulletProps) => {
  return (
    <StyledLegendBulletContainer>
      <StyledLegendBulletCircle color={color} />
      <StyledLegendBulletName>{name}</StyledLegendBulletName>
    </StyledLegendBulletContainer>
  );
};

export const getLegendBulletHTML = (color: string, name: string): string => {
  return renderToString(<LegendBullet color={color} name={name} />);
};
